import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatGPT3.css';

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature title="What is the best Gym Exercise?" text="Where the gym is a very ‘each to their own‘ environment, everyone has there own go-to exercises, routines and set ups. When it comes to exercises in your routine , some will always be advantageous, no matter what your approach. These exercises should have a place in most gym goers plan…" />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">Expand your horizons with power gym workouts</h1>
      <p>Learn Workout Techniques</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature title="Push Ups" text="Push ups are beneficial for building upper body strength. They work the triceps, pectoral muscles, and shoulders. When done with correct form, they can strengthen the lower back and core too! Pushups are a fast and effective exercise for building your strength." />
      <Feature title="Overhead press" text="Some prefer the standing barbell overhead press to bench press itself. This exercise demands huge effort from your abs and all the assistance muscles that get used to press the barbell (or dumbbells) overhead; this move can help massively develop your shoulders and chest and can be done standing or seated." />
      <Feature title="Squats" text="Whether it’s barbell, dumbbell or goblet style to ease the spinal compression, squats are an absolute foundation of leg training. They can be easily adapted too for people with poorer joints." />
    </div>
  </div>
);

export default WhatGPT3;
